<template>
  <div>
    <h1>Task</h1>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
</style>